import Shipment from '../../../../types/api/shipment'

export function getShipmentCopies(shipment?: Shipment): number {
    return (shipment?.shipment_positions || []).reduce(
        (acc, position) => acc + (position.copies || 0),
        0
    )
}
